import { Component, Vue, Prop as prop, Prop} from 'nuxt-property-decorator';

@Component({
    components: {
        customPicture: require('~/components/common/image/').default,
    }
})
export default class ConfiguratorImageRow extends Vue {

    @Prop() refs: Map<number, any>;
    @Prop() option;
    @Prop() current;
    @Prop() matchedOffers;

    get showLabel() {
        return !this.option.meta || this.option.meta.showLabel;
    }
}
